export type Lang = 'de' | 'en';

export const DE_TO_EN: Record<string, string> = {
  '/': '/en/',
  '/leistungen': '/en/services',
  '/leistungen/ki-telefonassistent': '/en/services/ai-phone-assistant',
  '/leistungen/prozessautomatisierung': '/en/services/process-automation',
  '/leistungen/ki-integration': '/en/services/ai-integration',
  '/leistungen/kostenoptimierung': '/en/services/cost-optimization',
  '/ki-beratung-wien': '/en/ai-consulting-vienna',
  '/referenzen': '/en/references',
  '/ueber-uns': '/en/about-us',
  '/kontakt': '/en/contact',
};

export const EN_TO_DE: Record<string, string> = Object.fromEntries(
  Object.entries(DE_TO_EN).map(([de, en]) => [en, de])
);

export function getAlternatePath(currentPath: string): string | undefined {
  if (DE_TO_EN[currentPath]) return DE_TO_EN[currentPath];
  if (EN_TO_DE[currentPath]) return EN_TO_DE[currentPath];
  return undefined;
}

export function isEnglishPath(path: string): boolean {
  return path.startsWith('/en/') || path === '/en';
}

export function getLangFromPath(path: string): Lang {
  return isEnglishPath(path) ? 'en' : 'de';
}
